import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function registerVists(uId, establishmentId, visitType) {
  return new Promise((resolve, reject) => {
    authToken(uId)
      .then((token) => {
        axios
          .post(
            `${cfac22('API_HOST_V2')}/users/visits`,
            {
              payload: { establishmentId, visitType },
            },
            {
              headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href },
            }
          )
          .then((result) => {
            // console.log("RESULT_REGISTER_VISITS: ", result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERROR_REGISTER_VISITS: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        //console.log("ERROR_TOKE:", error);
        reject(error);
      });
  });
}
